/* R&R paid-entry preview + resilient Meta detection. */
(() => {
  const targetCampaign = '120253289405460782';
  function setText(section, selector, value) {
    const el = section.querySelector(selector);
    if (el) el.textContent = value;
  }
  function run() {
    const section = document.querySelector('[data-rr-paid-entry]');
    if (!section || !document.body) return;
    const params = new URLSearchParams(location.search);
    const source = (params.get('utm_source') || '').toLowerCase();
    const medium = (params.get('utm_medium') || '').toLowerCase();
    const campaign = params.get('utm_campaign') || '';
    const hash = (location.hash || '').toLowerCase();
    const manualGift = hash === '#rr-paid-gift';
    const manualPaid = manualGift || hash === '#rr-paid' || params.get('rr_paid') === '1';
    const metaSource = ['fb','facebook','ig','instagram','meta'].includes(source);
    const paidMedium = /(^|_)(paid|paid_social|cpc)(_|$)/.test(medium) || medium === 'paid';
    const realPaid = metaSource && paidMedium;
    const campaignFallback = campaign === targetCampaign;
    const active = manualPaid || realPaid || campaignFallback;
    if (!active) {
      if (document.body.dataset.rrPaidBridge === 'true') {
        document.body.classList.remove('rr-paid-entry-active','rr-paid-entry-gift');
        section.hidden = true;
        delete document.body.dataset.rrPaidBridge;
      }
      return;
    }
    const eventLive = section.dataset.eventLive === 'true';
    const giftMode = eventLive && (manualGift || campaign === targetCampaign);
    document.body.dataset.rrPaidBridge = 'true';
    document.body.classList.add('rr-paid-entry-active');
    document.body.classList.toggle('rr-paid-entry-gift', giftMode);
    section.hidden = false;
    const primary = section.querySelector('[data-rr-paid-primary]');
    const secondary = section.querySelector('[data-rr-paid-secondary]');
    const art = section.querySelector('[data-rr-paid-art]');
    const image = section.querySelector('[data-rr-paid-image]');
    if (giftMode) {
      setText(section,'[data-rr-paid-kicker]','September 4 to 7');
      setText(section,'[data-rr-paid-line-one]','Pick your favorite.');
      setText(section,'[data-rr-paid-line-two]','We’ll pick the extra.');
      setText(section,'[data-rr-paid-copy]','Every order gets one surprise mini during the Labor Day Gift Event. No code. One mini per order.');
      setText(section,'[data-rr-paid-picks-title]','Pick what you want.');
      setText(section,'[data-rr-paid-picks-copy]','Start with a favorite, then we’ll tuck one surprise mini into the order.');
      if (primary) { primary.textContent = 'Shop the favorites'; primary.href = '#rr-paid-picks'; }
      if (secondary) { secondary.textContent = 'See the 5 minis'; secondary.href = '/collections/summer-sale?view=labor-day-gift-event'; }
      art?.classList.add('rr-paid-entry-art--gift');
      if (image && art) { image.src = art.dataset.giftSrc; image.alt = 'Five surprise R&R mini gifts for the September 4 to 7 event'; }
    } else {
      setText(section,'[data-rr-paid-kicker]','R&R BODY + HAIR CARE');
      setText(section,'[data-rr-paid-line-one]','Your next favorite.');
      setText(section,'[data-rr-paid-line-two]','Starts here.');
      setText(section,'[data-rr-paid-copy]','Body and hair care for your everyday. Start with the products shoppers are already reaching for.');
      setText(section,'[data-rr-paid-picks-title]','A good place to start.');
      setText(section,'[data-rr-paid-picks-copy]','These are the products shoppers have been reaching for most.');
      if (primary) { primary.textContent = 'Shop the favorites'; primary.href = '#rr-paid-picks'; }
      if (secondary) { secondary.textContent = 'Shop all care'; secondary.href = '/collections/all-products'; }
      art?.classList.remove('rr-paid-entry-art--gift');
      if (image && art) { image.src = art.dataset.evergreenSrc; image.alt = 'R&R body and hair care'; }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true}); else run();
  window.addEventListener('hashchange', run);
})();
